export const ITEM_SIZE = 48;
